<script setup lang="ts">

const { getHeroConfig } = useHome()
const { data: heroConfig } = await useAsyncData('home-hero-config', () => getHeroConfig())

// -- "Derniers ajouts" section disabled --
// To re-enable: uncomment the imports below, the aside in template, and the script logic
// const { getLatestUpdate, getHeroProjects } = useHome()
// const { data: projects } = await useAsyncData('home-hero-projects', () => getHeroProjects())
// const { data: updates } = await useAsyncData('home-hero-updates', () => getLatestUpdate())
// const currentProjectIndex = ref(0)
// const heroProject = computed(() => projects.value?.[currentProjectIndex.value] ?? null)
// const validUpdates = computed<HeroUpdate[]>(() => (updates.value && updates.value.length > 0) ? updates.value : [])
// const currentIndex = ref(0)
// const heroUpdate = computed(() => validUpdates.value[currentIndex.value])
// let rotationInterval: any = null
// let projectRotationInterval: any = null
// onMounted(() => {
//   if (projects.value && projects.value.length > 1) {
//     projectRotationInterval = setInterval(() => {
//       if (!projects.value) return
//       currentProjectIndex.value = (currentProjectIndex.value + 1) % projects.value.length
//     }, 6000)
//   }
// })
// watch(validUpdates, (newUpdates) => {
//     if (import.meta.client && rotationInterval) clearInterval(rotationInterval)
//     if (import.meta.client && newUpdates && newUpdates.length > 1) {
//         rotationInterval = setInterval(() => {
//             currentIndex.value = (currentIndex.value + 1) % newUpdates.length
//         }, 6000)
//     }
// }, { immediate: true })
// onUnmounted(() => {
//     if (rotationInterval) clearInterval(rotationInterval)
//     if (projectRotationInterval) clearInterval(projectRotationInterval)
// })
</script>

<template>
  <div class="flex flex-col">
    <!-- HERO via PageHero commun -->
    <UiPageHero
      height="screen"
      page-key="home"
      align="left"
      description="Une école à taille humaine pour apprendre à créer vos propres jeux vidéo à Narbonne."
      :tags="['APPRENDRE', 'CRÉER', 'PARTAGER']"
      :primary-button="{ text: 'REJOINDRE L\'ÉCOLE', to: '/candidature', umamiEvent: 'Home - Hero - Candidater' }"
      :secondary-button="{ text: 'VOIR LES CURSUS', to: '/formations', umamiEvent: 'Home - Hero - Formations' }"
    >
      <!-- Badge configurable depuis le backoffice -->
      <template v-if="heroConfig?.buttonVisible && heroConfig?.buttonText" #badge>
        <NuxtLink :to="heroConfig.buttonUrl" class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-oxo-yellow/10 border border-oxo-yellow/30 text-oxo-yellow text-sm font-medium tracking-wide animate-glow-pulse hover:bg-oxo-yellow/20 transition-colors cursor-pointer">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-oxo-yellow opacity-75"></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-oxo-yellow"></span>
          </span>
          {{ heroConfig.buttonText }}
        </NuxtLink>
      </template>

      <!-- Titre custom 2 lignes avec gradient OCCITANE -->
      <template #title>
        <h1 class="font-display font-black text-4xl md:text-5xl lg:text-5xl xl:text-6xl mb-4 md:mb-8 text-foreground uppercase leading-[1.1] animate-fade-in-up py-4" style="animation-delay: 0.2s">
          <span class="block xl:whitespace-nowrap">
            L'ÉCOLE <span class="bg-linear-to-r from-oxo-red to-oxo-yellow bg-clip-text text-transparent drop-shadow-[0_0_15px_rgba(186,49,37,0.5)] px-[0.05em] mx-[-0.05em]">OCCITANE</span>
          </span>
          <span class="block xl:whitespace-nowrap">DU JEU VIDÉO</span>
        </h1>
      </template>
    </UiPageHero>

    <!-- Section "Derniers ajouts" — DÉSACTIVÉE (décommenter pour réactiver) -->
    <!--
    <aside class="w-full bg-background py-section-py px-container-px relative z-40 border-b border-oxo-border" aria-label="Dernières nouveautés">
        <div class="container mx-auto">
            <header class="flex items-center gap-4 mb-8">
                <span class="w-8 h-px bg-oxo-border"></span>
                <h3 class="text-xs font-bold text-foreground-dim/40 uppercase tracking-[0.2em]">
                    Nos derniers ajouts
                </h3>
                <span class="flex-1 h-px bg-oxo-border"></span>
            </header>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
              <NuxtLink v-if="heroProject" :to="`/projets/${heroProject.slug}`" class="block group">
                  <article class="bg-oxo-card-bg rounded-2xl overflow-hidden shadow-xs hover:shadow-md transition-all border border-oxo-border">
                      <figure class="relative h-64 md:h-72 overflow-hidden transform-gpu m-0">
                          <NuxtImg loading="lazy" v-if="heroProject?.image" :src="heroProject.image" :alt="heroProject?.title" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" sizes="100vw md:50vw" />
                          <div v-else class="w-full h-full bg-oxo-dark/50 flex items-center justify-center">
                            <i class="fas fa-gamepad text-4xl text-white/20" aria-hidden="true"></i>
                          </div>
                          <div class="absolute inset-0 bg-linear-to-t from-black/90 via-black/20 to-transparent opacity-100 z-10"></div>
                          <figcaption class="absolute top-3 right-3 z-20" v-if="heroProject?.type && heroProject.type !== 'None'">
                              <UiBadge variant="warning" size="sm">{{ heroProject.type }}</UiBadge>
                          </figcaption>
                          <div class="absolute bottom-4 left-4 z-20 pr-4">
                            <span class="text-oxo-red text-[10px] font-bold uppercase tracking-wider mb-1 block">Projet {{ heroProject?.year }}</span>
                            <h2 class="text-lg font-bold text-white leading-tight group-hover:text-oxo-yellow transition-colors drop-shadow-md">{{ heroProject?.title }}</h2>
                            <div class="flex items-center gap-2 text-[10px] text-gray-300 font-mono mt-1">
                                <i class="fas fa-users text-oxo-red/70" aria-hidden="true"></i>
                                <span>{{ heroProject?.teamCount || heroProject?.team?.length || 0 }} Étudiants</span>
                            </div>
                          </div>
                      </figure>
                  </article>
              </NuxtLink>
              <div class="flex flex-col gap-6">
                  <div v-for="update in validUpdates" :key="update.slug">
                      <NuxtLink :to="update.type === 'event' ? `/actus/evenement/${update.slug}` : `/actus/${update.slug}`" class="block group">
                          <article class="bg-oxo-card-bg rounded-2xl border border-oxo-border shadow-xs hover:shadow-md transition-all overflow-hidden">
                              <div v-if="update.image" class="relative h-32 overflow-hidden">
                                  <NuxtImg loading="lazy" :src="update.image" :alt="update.title" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" sizes="100vw md:50vw" />
                                  <div class="absolute inset-0 bg-linear-to-t from-oxo-card-bg via-transparent to-transparent"></div>
                                  <span class="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider bg-black/50 backdrop-blur-xs border border-white/10" :class="update.type === 'event' ? 'text-oxo-yellow' : 'text-oxo-red'">
                                    <i :class="update.type === 'event' ? 'fas fa-calendar-alt' : 'fas fa-newspaper'" aria-hidden="true"></i>
                                    {{ update.type === 'event' ? 'Événement' : 'Actualité' }}
                                  </span>
                              </div>
                              <div class="p-5">
                                  <div class="flex items-center gap-4">
                                      <time class="flex flex-col items-center justify-center w-14 h-14 rounded-xl bg-background text-foreground border border-oxo-border shrink-0">
                                          <span class="text-oxo-red text-[10px] font-bold uppercase">{{ update.month }}</span>
                                          <span class="text-xl font-black">{{ update.day }}</span>
                                      </time>
                                      <div class="flex-1 min-w-0">
                                          <span class="text-[10px] font-bold text-oxo-yellow uppercase tracking-wider mb-1 block">{{ update.category }}</span>
                                          <h2 class="font-bold text-foreground leading-tight text-sm line-clamp-2 group-hover:text-oxo-red transition-colors">{{ update.title }}</h2>
                                      </div>
                                      <div class="w-8 h-8 rounded-full border border-oxo-border flex items-center justify-center text-foreground-dim/50 group-hover:bg-oxo-red group-hover:border-oxo-red group-hover:text-white transition-all shrink-0">
                                          <i class="fas fa-arrow-right text-xs transform group-hover:-rotate-45 transition-transform" aria-hidden="true"></i>
                                      </div>
                                  </div>
                              </div>
                          </article>
                      </NuxtLink>
                  </div>
              </div>
            </div>
        </div>
    </aside>
    -->
  </div>
</template>
